module.exports = __webpack_public_path__ + "static/media/stofferingen-22.aab30e4c.jpg";